import { literal, union } from "superstruct";

import { REVIEWS_SORTING_TYPE } from "../constants";

const ReviewsSortingOptionsSchema = union([
    literal(REVIEWS_SORTING_TYPE.MOST_RELEVANT),
    literal(REVIEWS_SORTING_TYPE.MOST_RECENT),
    literal(REVIEWS_SORTING_TYPE.HIGHEST_RATING),
    literal(REVIEWS_SORTING_TYPE.LOWEST_RATING),
    literal(REVIEWS_SORTING_TYPE.WITH_PHOTOS),
    literal(REVIEWS_SORTING_TYPE.MOST_HELPFUL),
]);

export default ReviewsSortingOptionsSchema;
